import { render } from "./PurchaseModal.vue?vue&type=template&id=7fd63629&scoped=true"
import script from "./PurchaseModal.vue?vue&type=script&lang=js"
export * from "./PurchaseModal.vue?vue&type=script&lang=js"

import "./PurchaseModal.vue?vue&type=style&index=0&id=7fd63629&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd63629"]])

export default __exports__